import * as React from 'react';

export default () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.115 1.06A91.837 91.837 0 0120 0c4.62 0 9.24.352 13.86 1.057a6 6 0 015.03 5.053c.74 5 1.11 9.63 1.11 13.89s-.37 8.89-1.11 13.89a6 6 0 01-5.03 5.053A91.834 91.834 0 0120 40c-4.628 0-9.257-.353-13.885-1.06a6 6 0 01-5.028-5.038C.362 29.087 0 24.452 0 20c0-4.453.362-9.087 1.087-13.902A6 6 0 016.115 1.06z"
          fill="#0067F4"
          opacity=".1"
        />
        <g transform="translate(10, 10)">
          <path
            d="M10 7a3 3 0 100 6 3 3 0 000-6z"
            stroke="#0067F4"
            strokeWidth="2"
          />
          <path
            d="M16.5 11.5l1.9 1.1a1 1 0 01.4 1.4l-1 1.7a1 1 0 01-1.4.4l-1.9-1.1a7 7 0 01-2.1 1.2V18a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1.8a7 7 0 01-2.1-1.2l-1.9 1.1a1 1 0 01-1.4-.4l-1-1.7a1 1 0 01.4-1.4l1.9-1.1a7 7 0 010-3l-1.9-1.1a1 1 0 01-.4-1.4l1-1.7a1 1 0 011.4-.4l1.9 1.1a7 7 0 012.1-1.2V2a1 1 0 011-1h2a1 1 0 011 1v1.8a7 7 0 012.1 1.2l1.9-1.1a1 1 0 011.4.4l1 1.7a1 1 0 01-.4 1.4l-1.9 1.1a7 7 0 010 3z"
            stroke="#0067F4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
